module.exports = __webpack_public_path__ + "img/voucher.5a6a2385.png";